<div
  class="dynamic-field form-select"
  [formGroup]="group"
  [ngClass]="[config.name + '-container', isRequired ? 'dynamic-field--required' : '']"
  [attr.data-test]="config.name"
>
  <label class="mb-0">{{ config.label | translate }}</label>
  <cwc-radio-group
    [formControlName]="config.name"
    [status]="fieldControl.invalid && !fieldControl.untouched ? 'error' : 'regular'"
    designVersion="v2"
    [ngClass]="{'inline-radios': showInline}"
  >
    <div [ngClass]="{'dynamic-form-field__item': true, 'inline-wrapper': showInline}" *ngFor="let option of options">
      <cwc-radio (cwcClick)="changeRadio(option.id)" [value]="option.id" designVersion="v2">
        {{ option.name }}
      </cwc-radio>
    </div>
  </cwc-radio-group>
</div>
